import { Button, Stack } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";
import { RedirectType } from "src/types/apps";

import Context from "../../../context";

export default function Actions({ id }: RedirectType) {
	const { actions } = useContext(Context);
	const { translate } = useLocales();

	const onDelete = () => {
		actions.showRemoveUriDialog(id);
	};

	return (
		<Stack flexDirection='row' alignItems='center' gap={2} justifyContent={"end"}>
			{/* <Button>{"Editar"}</Button> */}
			<Button color='error' onClick={onDelete}>
				{translate("api_client.delete")}
			</Button>
		</Stack>
	);
}
